<template>
    <div v-html="contents.health_safety_1.body" class="admin-generated"></div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'

    export default {
        name: "HealthSafetyIndex",
        props: {
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
        },
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        mounted () {
            //
        },
        methods:{
            //
        },
    }
</script>
<style scoped>
ol li::marker {
    font-weight: 400;
}
li {
    font-weight: 300;
}
.admin-generated >>> hr {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    font-family: ABCFavorit !important;
}
</style>
